import styled from "styled-components";
import { BADGE_COLORS, BADGE_TOOLTIPS } from "../../utils/verified";

// Small elegant circular badge with a white checkmark.
// type: "blue" | "gold" | "purple"
export const VerifiedBadge = ({ type = "blue", size = 16 }) => {
    const color = BADGE_COLORS[type] || BADGE_COLORS.blue;
    const tooltip = BADGE_TOOLTIPS[type] || "Verified by Fellora";
    return (
        <Badge
            type={type}
            size={size}
            color={color}
            role="img"
            aria-label={tooltip}
            title={tooltip}
        >
            <svg viewBox="0 0 24 24" width={size * 0.62} height={size * 0.62} fill="none">
                <path
                    d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                    fill="#fff"
                />
            </svg>
        </Badge>
    );
};

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${(p) => p.size}px;
    height: ${(p) => p.size}px;
    border-radius: 50%;
    background: ${(p) => p.color};
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.35);
    margin-left: 5px;
    flex-shrink: 0;
    vertical-align: -2px;
    cursor: default;
    transition: transform 0.18s ease, box-shadow 0.18s ease;

    &:hover {
        transform: scale(1.18);
        box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.5), 0 4px 12px rgba(10, 20, 40, 0.25);
    }
`;